import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserObject } from '../../models/userdetails';

import { DEFAULT_LANGUAGE } from '../../app-constants';
import * as AppConfig from '../config/AppConfig.json';

import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

interface Zone {
  countryCode: string;
  countryName: string;
  zoneName: string;
  gmtOffset: number;
  timestamp: number;
}

interface ApiResponse {
  status: string;
  message: string;
  zones: Zone[];
}

@Injectable()
export class CommonService {
  // baseUrl = 'http://18.194.142.198:3340/'; /**online */
  // baseUrl = 'http://192.168.1.44:2222/'; /**local */
  //baseUrl = 'http://103.121.26.82:1452/'; 
  baseUrl = 'https://api.ticketvoordeel.nl/'; /*for build */
  //baseUrl = 'http://localhost:53875/'; 
  baseImageUrl = 'http://103.121.26.82:1452/';
  disount = AppConfig.FLIGHT.discount;
  couponCodes: string[] = AppConfig.FLIGHT.CouponCodes;
  creditScore = AppConfig.FLIGHT.CreditMinScore;
  creditAmount = AppConfig.FLIGHT.CreditMinAmount;

  public myDatePickerOptions = {
    dateFormat: 'dd-mm-yyyy',
    selectionTxtFontSize: '16px',
    height: '60px',
    // editableDateField: false,
    // openSelectorOnInputClick: true
  };
  public searchDatePickerOptions = {
    dateFormat: 'dd-mm-yyyy',
    selectionTxtFontSize: '16px',
    height: '60px',
    editableDateField: true,
    openSelectorOnInputClick: true,
    yearSelector: true,
    minYear: new Date().getFullYear(),
    maxYear: new Date().getFullYear() + 1
  };
  public isLoggedIn = new BehaviorSubject<Boolean>(false);
  public isLoading = new BehaviorSubject<Boolean>(false);
  public userName = new BehaviorSubject<string>('');
  public defaultLang = DEFAULT_LANGUAGE;

  public userDetails = new BehaviorSubject<UserObject>(null);

  @Output() public showDirectFlightOnly: EventEmitter<any> = new EventEmitter();

  public showDirectFlightOnlySub = new BehaviorSubject<Boolean>(false);
  locationData: Observable<ApiResponse>;


  constructor(private _http: HttpClient) { }

  public isInDirectFlights: boolean = false;
  private isInDirect = new BehaviorSubject(this.isInDirectFlights);
  isInDirectValue = this.isInDirect.asObservable();

  isInDirectFlight(value: boolean) {
    this.isInDirect.next(value);
  }
  /**Method to load js scripts written for styling HTML elements*/
  loadScript() {
    const scriptsArray = ['assets/js/script.js', 'assets/js/core.min.js'];
    for (let i = 0; i < scriptsArray.length; i++) {
      const node = document.createElement('script');
      node.src = scriptsArray[i];
      node.type = 'text/javascript';
      node.async = false;
      node.id = 'custom_js';
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  showLoader() {
    this.isLoading.next(true);
  }

  hideLoader() {
    this.isLoading.next(false);
  }

  setUserDetails(userObject: UserObject) {
    this.userDetails.next(userObject);
  }

  /**Method to return image src path according to the given airline code */
  getLogoPath(airlineCode) {
    const logoPath = 'assets/images/airlines_logos/logo_' + airlineCode + '.png';
    //console.log(airlineCode);
    return logoPath;
  }

  /**Method for returning image path of mini logos of airlines to be shown in filter section */
  getMiniLogoPath(airlineCode) {
    const logoPath = 'assets/images/airlines_logos/' + airlineCode + '_mini.png';
    return logoPath;
  }

  getFooterLinks() {
    return (this._http.get(this.baseUrl + 'getfooterlinks'));
  }

  getCounterValue() {
    return (this._http.get(this.baseUrl + 'getVisitorCount'));
  }

  subscribeNewsLetter(params: string, name: string) {
    return (this._http.get(this.baseUrl + 'SubscribeNewsletter?' + 'email=' + params + '&name=' + name));

  }

  getDynamicPageDetail(id: any) {
    return (this._http.get(this.baseUrl + 'getdynamicpage/' + id));
  }

  postIncompleteBooking(imageData: any, personalDetails: any, step: any, uniqueId: any, name: any = null, email: any = null) {
    const params = {
      imageData: imageData,
      personalDetails: personalDetails,
      step: step,
      uniqueId: uniqueId,
      FirstName: name,
      FirstEmail: email
    };
    const headers: HttpHeaders = new HttpHeaders();
    this._http.post(this.baseUrl + 'incompletebookingmail', params).subscribe(
      (response) => {

        // handle successful response
      },
      (error) => {
        //console.log('Error:', error);
        // handle error

      }
    );
  }

  generateRandomString(): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 15; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }


  invokeEvent: Subject<any> = new Subject();

  callAddFilterOfFilterComponent() {
    this.invokeEvent.next();
  }

  GetAllLocationInformation() {
    const apiKey = 'EKSHN213XFN5';
    const apiUrl = `http://api.timezonedb.com/v2.1/list-time-zone?key=${apiKey}&format=json`;
    var tt = this._http.get<ApiResponse>(apiUrl);
    return tt;
  }

  getTimeZoneName(countryCode: string): string {
    let timeZoneName: string;

    switch (countryCode.toUpperCase()) {
      case "AMS":
      case "RTM":
      case "THE":
      case "UTRE":
      case "GRQ":
      case "MAA":
      case "HLM":
      case "ENS":
      case "ARN":
      case "LWD":
      case "AMR":
      case "ZWO":
      case "LEY":
      case "DOR":
      case "AMS":
      case "RTM":
      case "EIN":
      case "MST":
      case "DHR":
      case "LWR":
      case "LID":
      case "GLZ":
      case "LEL":
      case "DHR":
      case "QYI":
      case "EHSE":
      case "LID":
        timeZoneName = "Europe/Amsterdam";
        break;
      case "BRU":
      case "ANR":
      case "CRL":
      case "LGG":
      case "OST":
      case "GRQ":
        timeZoneName = "Europe/Brussels";
        break;
      case "SOF":
      case "VAR":
      case "PDV":
      case "BOJ":
      case "LCA":
        timeZoneName = "Europe/Sofia";
        break;
      case "CPH":
      case "AAL":
      case "BLL":
      case "EBJ":
        timeZoneName = "Europe/Copenhagen";
        break;
      case "HEL":
      case "TKU":
      case "TMP":
      case "RVN":
      case "OUL":
        timeZoneName = "Europe/Helsinki";
        break;
      case "PAR":
      case "ORY":
      case "BVA":
      case "XCR":
      case "CDG":
        timeZoneName = "Europe/Paris";
        break;
      case "BER":
      case "TXL":
      case "SXF":
      case "THF":
        timeZoneName = "Europe/Berlin";
        break;
      case "ATH":
      case "SKG":
      case "HER":
      case "RHO":
      case "JTR":
        timeZoneName = "Europe/Athens";
        break;
      case "BUD":
      case "DEB":
        timeZoneName = "Europe/Budapest";
        break;
      case "DUB":
      case "ORK":
      case "SNN":
      case "KIR":
        timeZoneName = "Europe/Dublin";
        break;
      case "ROM":
      case "CIA":
      case "FCO":
        timeZoneName = "Europe/Rome";
        break;
      case "OSL":
      case "TRF":
      case "RYG":
        timeZoneName = "Europe/Oslo";
        break;
      case "WAR":
      case "WMI":
        timeZoneName = "Europe/Warsaw";
        break;
      case "LIS":
      case "FAO":
      case "OPO":
      case "PXO":
        timeZoneName = "Atlantic/Azores";
        break;
      case "BUC":
      case "OTP":
        timeZoneName = "Europe/Bucharest";
        break;
      case "MOS":
      case "DME":
      case "SVO":
      case "VKO":
      case "ZIA":
        timeZoneName = "Europe/Kaliningrad";
        break;
      case "BEL":
      case "BEG":
      case "INI":
        timeZoneName = "Europe/Belgrade";
        break;
      case "MAD":
      case "BCN":
      case "AGP":
      case "VLC":
      case "SVQ":
        timeZoneName = "Europe/Madrid";
        break;
      case "STO":
      case "ARN":
      case "BMA":
      case "NYO":
        timeZoneName = "Europe/Stockholm";
        break;
      case "ZUR":
      case "GVA":
      case "BSL":
        timeZoneName = "Europe/Zurich";
        break;
      case "IST":
      case "SAW":
      case "AYT":
      case "IST":
      case "AYT":
      case "SAW":
      case "DLM":
      case "ADB":
      case "ESB":
      case "BJV":
      case "ADA":
      case "GZT":
      case "TZX":
      case "ERZ":
      case "ISE":
      case "ISL":
      case "GZP":
      case "DIY":
      case "HTY":
      case "EZS":
      case "ASR":
      case "GNY":
      case "MLX":
      case "VAN":
      case "DNZ":
      case "ERC":
      case "KYA":
      case "BAL":
      case "MSR":
      case "KCM":
      case "MQM":
      case "EDO":
      case "KSY":
        timeZoneName = "Europe/Istanbul";
        break;
      case "KYI":
      case "IEV":
        timeZoneName = "Europe/Kyiv";
        break;
      case "LON":
      case "LHR":
      case "LGW":
      case "LCY":
      case "STN":
      case "LTN":
        timeZoneName = "Europe/London";
        break;
      default:
        timeZoneName = "Unknown";
        break;
    }

    return timeZoneName;
  }

  getLocationOffset(depLocation: string, arrLocation: string): Observable<any> {

    return (this._http.get(this.baseUrl + 'getlocationoffset?' + 'depLocation=' + this.getTimeZoneName(depLocation) + '&arrLocation=' + this.getTimeZoneName(arrLocation)));
  }


  getCountryName(countryCode: string): string {
    let timeZoneName: string;

    switch (countryCode.toUpperCase()) {
      case "AMS":
      case "RTM":
      case "THE":
      case "UTRE":
      case "GRQ":
      case "MAA":
      case "HLM":
      case "ENS":
      case "ARN":
      case "LWD":
      case "AMR":
      case "ZWO":
      case "LEY":
      case "DOR":
      case "AMS":
      case "RTM":
      case "EIN":
      case "MST":
      case "DHR":
      case "LWR":
      case "LID":
      case "GLZ":
      case "LEL":
      case "QYI":
      case "EHSE":
      case "ROT":
      case "RTM":
        timeZoneName = "NL";
        break;
      case "BRU":
      case "ANR":
      case "CRL":
      case "LGG":
      case "OST":
      case "GRQ":
        timeZoneName = "BE";
        break;
      case "IST":
      case "SAW":
      case "AYT":
      case "IST":
      case "AYT":
      case "SAW":
      case "DLM":
      case "ADB":
      case "ESB":
      case "BJV":
      case "ADA":
      case "GZT":
      case "TZX":
      case "ERZ":
      case "ISE":
      case "ISL":
      case "GZP":
      case "DIY":
      case "HTY":
      case "EZS":
      case "ASR":
      case "GNY":
      case "MLX":
      case "VAN":
      case "DNZ":
      case "ERC":
      case "KYA":
      case "BAL":
      case "MSR":
      case "KCM":
      case "MQM":
      case "EDO":
      case "KSY":
        timeZoneName = "TR";
        break;
      case "FRA":
      case "MUC":
      case "TXL":
      case "SXF":
      case "HAM":
      case "DUS":
      case "CGN":
      case "STR":
      case "HAJ":
      case "NUE":
      case "LEJ":
      case "DRS":
      case "BRE":
      case "FMM":
      case "DTM":
      case "FDH":
      case "PAD":
      case "ERF":
      case "FKB":
      case "RLG":
        timeZoneName = "DE";
        break;
      default:
        timeZoneName = "Unknown";
        break;
    }

    return timeZoneName;
  }

  


}
